import {
  ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Setting Saldo Awal',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Saldo Awal',
        href: '/adm/fin/setting/saldo-awal',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: false,
    fields: [
      {
        key: 'code_acc',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'acc_name',
        label: 'Nama Akun',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Mata Uang',
        sortable: true,
      },
      {
        key: 'saldo_awal',
        label: 'Saldo Awal',
        thStyle: { width: '170px' },
        sortable: true,
      },
    ],
    form: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  settingSaldoAwal(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getKlasifikasi(context, params = null) {
    let result = await ApiGetRequest(`opr/customers`, params);
    return !result.error ? result.data.object : [];
  },

  async updateSaldo({ commit, dispatch }, payload = null) {
    commit('settingSaldoAwal', {
      loading: true,
    });

    let result = await ApiPostRequest(`fin/saldo-awal`, payload.form);
    commit('settingSaldoAwal', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    return false;
  },

  async getSaldoBefore({ commit }) {
    commit('settingSaldoAwal', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/saldo-awal/transaksi`);
    commit('settingSaldoAwal', {
      loading: false,
    });

    if (!result.error) {
      return result.data.object;
    }

    return false;
  },

  async getListSaldoAwal({ commit, state }) {
    commit('settingSaldoAwal', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/saldo-awal`, params);
    commit('settingSaldoAwal', {
      loading: false,
    });

    if (!result.error) {
      commit('settingSaldoAwal', {
        items: result.data.object || [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },
};
